import { Feature } from '@urbanx/agx.agencies.client';
import { StaffRole } from '@urbanx/agx.auth.client';
import { SideMenu } from 'types/commonTypes';
import AgenciesIcon from 'components/sidebar/icons/agencies-icon';
import TasksIcon from 'components/sidebar/icons/tasks-icon';
import ReportingIcon from 'components/sidebar/icons/reporting-icon';
import SettingsIcon from 'components/sidebar/icons/settings-icon';
import CampaignsIcon from 'components/sidebar/icons/campaigns-icon';
import ContractsIcon from 'components/sidebar/icons/contracts-icon';

export enum Pages {
  DASHBOARD = '/',
  AGENCIES = 'agencies',
  BRANDING = 'branding',
  AGENCY_DETAILS = 'agency-details',
  LISTING_AGREEMENT = 'listing-agreement',
  CONTRACT_SETTING = 'contract-setting',
  PARTNERSHIP = 'partnership',
  INTEGRATIONS = 'integrations',
  CRM = 'crm',
  MARKETING = 'marketing',
  CAMPAIGNS = 'campaigns',
  STAFF = '/staff',
  EDIT_STAFF = '/edit-staff',
  CREATE_STAFF = '/create-staff',
  STAFF_LICENSE = '/staff-license',
  AGREEMENT = 'agreement',
  PROPERTY_INFORMATION = 'manage',
  PROPERTY_INFORMATION_SECTION = 'property-information',
  PROPERTY_INFORMATION_PROPERTY_DETAILS = 'property-information/property-details',
  PROPERTY_INFORMATION_VENDOR_DETAILS = 'property-information/vendor-details',
  PROPERTY_INFORMATION_CONTRACT = 'property-information/contract',
  PROPERTY_INFORMATION_TENANCY_INFORMATION = 'property-information/tenancy-information',
  PROPERTY_INFORMATION_IDENTITY_VERIFICATION = 'property-information/identity-verification',
  FILES = 'files',
  PERMISSIONS = 'permissions',
  WEBSITE_LISTINGS = 'website-listings',
  CAMPAIGN_MARKETING = 'campaign-marketing',
  CONTRACTS = 'contracts',
  CONTRACT_TASKS = 'contract-tasks',

  FINANCE = 'finance',
  ACTIVITY = 'activity',
  // EMAILS = 'emails',
  BUYERS_INFORMATION = 'buyers-information',
  BUYERS_SOLICITOR = 'buyers-solicitor',
  BUYERS_AGENT = 'buyers-agent',
  BUYERS_IDENTITY_VERIFICATION = 'buyers-identity-verification',
  CAMPAIGN_OVERVIEW = 'campaign-overview',
  CAMPAIGN_TASKS = 'campaign-tasks',
  SALE_INFORMATION = 'sale-information',
  CONDITIONS = 'conditions',
  SPECIAL_CONDITIONS = 'special-conditions',
  SETTLEMENT = 'settlement',
  DEPOSITS = 'deposits',

  COMMISSION_COMMISSION = 'commission',
  COMMISSION_SERVICE_FEE = 'service-fee',
  COMMISSION_REFERRAL = 'referral',
  FINANCE_COMMISSION = 'finance/commission',
  FINANCE_SERVICE_FEE = 'finance/service-fee',
  FINANCE_REFERRAL = 'finance/referral',
  FINANCE_VPA = 'finance/vpa',

  TEAMS = 'teams',

  TEAMS_MEMBERS = 'team-members',
  TEAMS_MEMBERS_ADD = 'add',
  TEAMS_MEMBERS_EDIT = 'edit',

  TEAMS_MANAGE_TEAMS = 'manage-teams',
  TEAMS_MANAGE_TEAMS_ADD = 'add',
  TEAMS_MANAGE_TEAMS_EDIT = 'edit',

  TEAMS_URBANX_TEAM = 'urbanx-team',

  SUPPORT = 'support',
  SUPPORT_QUEUES = 'poison-queues',
  SUPPORT_MIGRATIONS = 'migrations',
  SUPPORT_UPDATE_LEGAL_NAME = 'update-legal-name',
  SUPPORT_UPDATE_CAMPAIGN_STATUS = 'update-campaign-status',
  SUPPORT_TASK_PROGRESSOR = 'task-progressor',
  SUPPORT_CRM = 'crm',
  SUPPORT_AGENT_INTEGRATIONS = 'agent-integrations',
  SUPPORT_RESTORE_SOFT_DELETED_AGENT = 'restore-soft-deleted-agent',
  SUPPORT_LEADERBOARD_VISIBILITY = 'leaderboard-visibility',
  SUPPORT_MANUAL_DOCUSIGN_UPDATES = 'manual-docusign-updates',
  FEATURE_TOGGLES = 'feature-toggles',

  REPORTING_PAGE = 'reporting',

  REPORTING_PARTNERS = 'partners',

  REPORTING_PARTNERS_PARTNER = 'partner',

  REPORTING_PARTNERS_INDIVIDUALS = 'individuals',
  REPORTING_PARTNERS_LEADERBOARD = 'leaderboard',

  TASKS_DASHBOARD = 'tasks-taskboard',
  ALL_TASKS = 'all-tasks',
  PROPOSALS = 'proposals',
  AUTOMATION_ERRORS = 'error-log',
  CAMPAIGN_ERRORS = 'errors',
}

export enum MenuTitles {
  HOME = 'Home',
  TEAM = 'Team',
  BRANDING = 'Branding',
  LICENSEE_DETAILS = 'Licensee Details',
  AGENCY_DETAILS = 'Agency Details',
  DOCUMENT_DEFAULTS = 'Document Defaults',
  LISTING_AGREEMENT = 'Listing Agreement',
  INTEGRATIONS = 'Integrations',
  CRM = 'CRM',
  MARKETING = 'Marketing',
  PROPOSALS = 'Proposals',
  CAMPAIGNS = 'Campaigns',
  CAMPAIGN = 'Campaign',
  AGREEMENT = 'Agreement',
  PROPERTY_INFORMATION = 'Property Information',
  FILES = 'Files',
  PERMISSIONS = 'Permissions',
  PARTNERSHIP = 'Partnership',
  WEBSITE_LISTINGS = 'Website Listings',
  CAMPAIGN_MARKETING = 'Marketing',
  CAMPAIGN_OVERVIEW = 'Overview',
  CAMPAIGN_TASKS = 'Tasks',
  CONTRACTS = 'Contracts',
  FINANCE = 'Finance',
  CONTRACT = 'Contract',
  PROPERTY_DETAILS = 'Property Details',
  VENDOR_DETAILS = 'Vendor Details',
  TENANCY_INFORMATION = 'Tenancy Information',
  IDENTITY_VERIFICATION = 'Identity Verification',
  CONTRACT_TASKS = 'Tasks',
  COMMISSION = 'Commission',
  COMMISSION_COMMISSION = 'Commission',
  COMMISSION_SERVICE_FEE = 'URBAN X Service Fee',
  COMMISSION_REFERRAL = 'Referral / Conjunction',
  FINANCE_VPA = 'VPA',
  SETTINGS = 'Settings',
  ACTIVITY = 'Activity',
  // EMAILS = 'Emails',
  BUYERS_DETAILS = 'Buyer Details',
  CONTRACT_INFORMATION = 'Contract Information',
  ERRORS = 'Errors',
}

export const Menu: SideMenu[] = [
  {
    title: MenuTitles.CAMPAIGNS,
    pageLink: Pages.CAMPAIGNS,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.WEBSITE_LISTINGS,
    pageLink: Pages.WEBSITE_LISTINGS,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.MARKETING,
    pageLink: Pages.MARKETING,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.PROPOSALS,
    pageLink: Pages.PROPOSALS,
    includeOnlyInState: [],
    requiredFeature: Feature.Proposals,
  },
  {
    title: MenuTitles.TEAM,
    pageLink: Pages.TEAMS,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.PARTNERSHIP,
    pageLink: Pages.PARTNERSHIP,
    includeOnlyInState: [],
    requiredRoles: [StaffRole.BusinessManager, StaffRole.SuperAdmin, StaffRole.Executive],
  },
  {
    title: MenuTitles.AGENCY_DETAILS,
    pageLink: Pages.AGENCY_DETAILS,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.SETTINGS,
    pageLink: Pages.BRANDING,
    includeOnlyInState: [],
  },
  // {
  //   title: MenuTitles.EMAILS,
  //   pageLink: Pages.EMAILS,
  //   includeOnlyInState: [],
  // },
];

export const SettingsMenu: SideMenu[] = [
  {
    title: MenuTitles.BRANDING,
    pageLink: Pages.BRANDING,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.INTEGRATIONS,
    pageLink: Pages.INTEGRATIONS,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.CRM,
    pageLink: Pages.CRM,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.LISTING_AGREEMENT,
    pageLink: Pages.LISTING_AGREEMENT,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.CONTRACT,
    pageLink: Pages.CONTRACT_SETTING,
    includeOnlyInState: [],
  },
  // {
  //   title: MenuTitles.COMMISSION,
  //   pageLink: Pages.LISTING_AGREEMENT,
  //   includeOnlyInState: [AustralianState.QLD],
  // }
];

export const StaffMenu: SideMenu[] = [
  {
    title: MenuTitles.HOME,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.TEAM,
    pageLink: Pages.STAFF,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.LICENSEE_DETAILS,
    pageLink: Pages.STAFF_LICENSE,
    includeOnlyInState: [],
  },
];

export const BlankContractMenu: SideMenu[] = [
  {
    title: MenuTitles.CAMPAIGN_TASKS,
    pageLink: Pages.CAMPAIGN_TASKS,
    includeOnlyInState: [],
    isHidden: true,
    requiredRoles: [StaffRole.WorkflowContributor],
  },
  /* TODO: Enable once functionality is implemented
  {
    title: MenuTitles.AGREEMENT,
    pageLink: Pages.AGREEMENT,
  }, */
  {
    title: MenuTitles.PROPERTY_INFORMATION,
    pageLink: Pages.PROPERTY_INFORMATION,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.CAMPAIGN_MARKETING,
    pageLink: Pages.CAMPAIGN_MARKETING,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.PERMISSIONS,
    pageLink: Pages.PERMISSIONS,
    includeOnlyInState: [],
  },
];

export const NswPropertyInformationMenu: SideMenu[] = [
  {
    title: MenuTitles.PROPERTY_DETAILS,
    pageLink: Pages.PROPERTY_INFORMATION_PROPERTY_DETAILS,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.VENDOR_DETAILS,
    pageLink: Pages.PROPERTY_INFORMATION_VENDOR_DETAILS,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.CONTRACT,
    pageLink: Pages.PROPERTY_INFORMATION_CONTRACT,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.TENANCY_INFORMATION,
    pageLink: Pages.PROPERTY_INFORMATION_TENANCY_INFORMATION,
    includeOnlyInState: [],
  },
];

export const SELECTED_CAMPAIGN_TOP_MENU: SideMenu[] = [
  {
    title: MenuTitles.CAMPAIGN_OVERVIEW,
    pageLink: Pages.CAMPAIGN_OVERVIEW,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.CAMPAIGN,
    pageLink: Pages.PROPERTY_INFORMATION,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.CONTRACTS,
    pageLink: Pages.CONTRACTS,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.FINANCE,
    pageLink: Pages.FINANCE_COMMISSION,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.ACTIVITY,
    pageLink: Pages.ACTIVITY,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.FILES,
    pageLink: Pages.FILES,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.ERRORS,
    pageLink: Pages.CAMPAIGN_ERRORS,
    includeOnlyInState: [],
  },
];

export const ContractsMenu: SideMenu[] = [
  {
    title: MenuTitles.CONTRACT_TASKS,
    pageLink: Pages.CONTRACT_TASKS,
    includeOnlyInState: [],
    requiredRoles: [StaffRole.WorkflowContributor],
  },
  {
    title: MenuTitles.BUYERS_DETAILS,
    pageLink: Pages.BUYERS_INFORMATION,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.CONTRACT_INFORMATION,
    pageLink: Pages.SALE_INFORMATION,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.FILES,
    pageLink: Pages.FILES,
    includeOnlyInState: [],
  },
];

export const CommissionMenu: SideMenu[] = [
  {
    title: MenuTitles.COMMISSION_COMMISSION,
    pageLink: Pages.FINANCE_COMMISSION,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.COMMISSION_SERVICE_FEE,
    pageLink: Pages.FINANCE_SERVICE_FEE,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.COMMISSION_REFERRAL,
    pageLink: Pages.FINANCE_REFERRAL,
    includeOnlyInState: [],
  },
];

export const FinanceMenu: SideMenu[] = [
  {
    title: MenuTitles.COMMISSION,
    pageLink: Pages.FINANCE_COMMISSION,
    includeOnlyInState: [],
  },
  {
    title: MenuTitles.FINANCE_VPA,
    pageLink: Pages.FINANCE_VPA,
    includeOnlyInState: [],
  },
];

// Enhanced menu configuration for dynamic sidebar
export interface MenuItemConfig {
  id: string;
  title: string;
  icon?: React.ComponentType<{ opacity?: number; color?: string; padding?: string }>;
  path?: string;
  hasSubmenu?: boolean;
  submenuItems?: MenuItemConfig[];
  state?: any;
  requiredRoles?: StaffRole[];
  isActive?: boolean;
  isHidden?: boolean;
  requiredFeature?: Feature;
}

export const DYNAMIC_MENU_CONFIG: MenuItemConfig[] = [
  {
    id: 'tasks',
    title: 'Tasks',
    icon: TasksIcon,
    path: '/',
    hasSubmenu: true,
    submenuItems: [
      {
        id: 'tasks-dashboard',
        title: 'Dashboard',
        path: `/${Pages.TASKS_DASHBOARD}`,
      },
      {
        id: 'all-tasks',
        title: 'All Tasks',
        path: `/${Pages.ALL_TASKS}`,
      },
    ],
  },
  {
    id: 'campaigns',
    title: 'Campaigns',
    icon: CampaignsIcon,
    path: '/campaigns',
    hasSubmenu: false,
  },
  {
    id: 'contracts',
    title: 'Contracts',
    icon: ContractsIcon,
    path: '/contracts',
    hasSubmenu: false,
  },
  {
    id: 'agencies',
    title: 'Agencies',
    icon: AgenciesIcon,
    path: '/agencies',
    hasSubmenu: false,
  },
  {
    id: 'reporting',
    title: 'Reporting',
    icon: ReportingIcon,
    hasSubmenu: true,
    submenuItems: [
      {
        id: 'network',
        title: 'Network',
        path: '/network',
      },
      {
        id: 'executive',
        title: 'Executive',
        path: '/executive-report',
      },
      {
        id: 'partners',
        title: 'Partners',
        path: `${Pages.REPORTING_PAGE}/${Pages.REPORTING_PARTNERS}`,
      },
      {
        id: 'discrepancies',
        title: 'Discrepancies',
        path: '/discrepancies',
      },
    ],
  },
  {
    id: 'urbanx',
    title: 'Settings',
    icon: SettingsIcon,
    hasSubmenu: true,
    submenuItems: [
      {
        id: 'staff-members',
        title: 'Staff Members',
        path: '/staff',
        state: { action: 'view' },
      },
      {
        id: 'agency-details',
        title: 'Agency Details',
        path: '/staff-license',
      },
      {
        id: Pages.SUPPORT,
        title: 'Support',
        path: `/${Pages.SUPPORT}`,
        requiredRoles: [StaffRole.SuperAdmin, StaffRole.Executive],
      },
      {
        id: Pages.FEATURE_TOGGLES,
        title: 'Feature Toggles',
        path: `/${Pages.FEATURE_TOGGLES}`,
        requiredRoles: [StaffRole.SuperAdmin, StaffRole.Executive],
      },
      {
        id: Pages.AUTOMATION_ERRORS,
        title: 'Error Log',
        path: `/${Pages.AUTOMATION_ERRORS}`,
        requiredRoles: [StaffRole.SuperAdmin, StaffRole.Executive],
      },
    ],
  },
  {
    id: 'settings',
    title: 'Settings',
    icon: SettingsIcon,
    path: '/settings',
    hasSubmenu: false,
    isHidden: true,
  },
];

export const getRouteMap = (): Record<
  string,
  { activeLink: string; menuStates?: Record<string, boolean> }
> => {
  return {
    '/': {
      activeLink: 'Dashboard',
      menuStates: { tasks: true, urbanx: false, reporting: false },
    },
    [`/${Pages.TASKS_DASHBOARD}`]: {
      activeLink: 'Dashboard',
      menuStates: { tasks: true, urbanx: false, reporting: false },
    },
    [`/${Pages.ALL_TASKS}`]: {
      activeLink: 'All Tasks',
      menuStates: { tasks: true, urbanx: false, reporting: false },
    },
    '/campaigns': { activeLink: 'Campaigns' },
    '/contracts': { activeLink: 'Contracts' },
    '/agencies': { activeLink: 'Agencies' },
    '/network': {
      activeLink: 'Network',
      menuStates: { urbanx: false, reporting: true },
    },
    '/executive-report': {
      activeLink: 'Executive',
      menuStates: { urbanx: false, reporting: true },
    },
    [`${Pages.REPORTING_PAGE}/${Pages.REPORTING_PARTNERS}`]: {
      activeLink: 'Partner',
      menuStates: { urbanx: false, reporting: true },
    },
    '/discrepancies': {
      activeLink: 'Discrepancies',
      menuStates: { urbanx: false, reporting: true },
    },
    '/staff': {
      activeLink: 'Staff Members',
      menuStates: { urbanx: true, reporting: false },
    },
    [Pages.CREATE_STAFF]: {
      activeLink: 'Staff Members',
      menuStates: { urbanx: true, reporting: false },
    },
    '/staff-license': {
      activeLink: 'Agency Details',
      menuStates: { urbanx: true, reporting: false },
    },
    [`/${Pages.SUPPORT}`]: {
      activeLink: 'Support',
      menuStates: { urbanx: true, reporting: false },
    },
    [`/${Pages.FEATURE_TOGGLES}`]: {
      activeLink: 'Feature Toggles',
      menuStates: { urbanx: true, reporting: false },
    },
    [`/${Pages.AUTOMATION_ERRORS}`]: {
      activeLink: 'Error Log',
      menuStates: { urbanx: true, reporting: false },
    },
  };
};

export const filterMenuConfig = (
  menuItems: MenuItemConfig[],
  userRoles: StaffRole[],
  enabledFeatures: Set<Feature>
): MenuItemConfig[] =>
  menuItems.flatMap((item) => {
    if (item.isHidden) return [];
    if (item.requiredFeature && !enabledFeatures.has(item.requiredFeature)) return [];
    if (
      item.requiredRoles?.length &&
      !item.requiredRoles.some((requiredRole) => userRoles.includes(requiredRole))
    ) {
      return [];
    }

    return [
      {
        ...item,
        ...(item.submenuItems
          ? { submenuItems: filterMenuConfig(item.submenuItems, userRoles, enabledFeatures) }
          : {}),
      },
    ];
  });

export const filterSideMenuByFeatures = (
  menuItems: SideMenu[],
  enabledFeatures: Set<Feature>
): SideMenu[] =>
  menuItems.filter((item) => !item.requiredFeature || enabledFeatures.has(item.requiredFeature));

// Utility function to filter SideMenu based on user roles
export const filterSideMenuByRoles = (
  menuItems: SideMenu[],
  userRoles: StaffRole[]
): SideMenu[] => {
  return menuItems.filter((item) => {
    // If no required roles, show the item to everyone
    if (!item.isHidden && (!item.requiredRoles || item.requiredRoles.length === 0)) {
      return true;
    }

    // Check if user has at least one of the required roles
    const hasRequiredRole = item.requiredRoles?.some((requiredRole) =>
      userRoles.includes(requiredRole)
    );
    item.isHidden = !hasRequiredRole;
    return !!hasRequiredRole;
  });
};
